import "./App.css";
import { BrowserRouter as Router, Navigate, Route, Routes } from "react-router-dom";
import Main from "./Component/Main";
import ProductDetail from "./Component/ProductDetail";
import CartPage from "./Component/CartPage";
import CheckOut from "./Component/CheckOut";
import { CartProvider } from "./Component/CartContext";
import Shop from "./Component/Shop";
import Contact from "./Component/Contact";
import About from "./Component/About";
import Header from "./Component/Header";
import Footer from "./Component/Footer";
import PolicyPage from "./Component/PolicyPage";
import PolicyLibrary from "./Component/PolicyLibrary";
import PaymentResult from "./Component/PaymentResult";
import { policies } from "./policies";

function App() {
  return (
    <CartProvider>
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Header />
        <Routes>
          <Route path="/" element={<Main />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/shopDetails/:id" element={<ProductDetail />} />
          <Route path="/product/:id" element={<Navigate to="/shop" replace />} />
          <Route path="/cartpage" element={<CartPage />} />
          <Route path="/checkout" element={<CheckOut />} />
          <Route path="/payment" element={<PaymentResult />} />
          <Route path="/paysuccess" element={<Navigate to="/payment?state=success" replace />} />
          <Route path="/policies" element={<PolicyLibrary />} />
          {policies.map((policy) => <Route key={policy.slug} path={`/policies/${policy.slug}`} element={<PolicyPage policy={policy} />} />)}
          <Route path="/privacy" element={<Navigate to="/policies/privacy" replace />} />
          <Route path="/terms" element={<Navigate to="/policies/terms" replace />} />
          <Route path="/shipping" element={<Navigate to="/policies/shipping" replace />} />
          <Route path="/returns" element={<Navigate to="/policies/returns" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Footer />
      </Router>
    </CartProvider>
  );
}

export default App;
